// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1Nt2g","header":"PatientQuestionnaire_header__qg--Y","info":"PatientQuestionnaire_info__3_zkZ"};